// extracted by mini-css-extract-plugin
export var deleteModal = "_rm-0";